import { PolicyLayout } from '../components/PolicyLayout';
import { siteDetails } from '../lib/site';

export const Privacy = () => (
  <PolicyLayout eyebrow="Legal" title="Privacy Policy" updated="17 September 2026">
    <p>
      This policy explains how ADarveo handles information about account holders, campaign teams, and
      people who open public scan experiences. We collect only the information reasonably needed to
      provide, secure, support, and improve the software.
    </p>

    <h2>Information we collect</h2>
    <p>
      Account information may include your name, email address, organization, authentication details,
      account settings, support messages, and campaign configuration. Paddle processes checkout and
      payment information as Merchant of Record; ADarveo does not receive or store complete payment-card
      details.
    </p>
    <p>
      Public experience data may include anonymous visitor and session identifiers, timestamps, scan
      and recognition events, video interactions, CTA clicks, browser and device metadata, referrer and
      campaign parameters, and approximate location supplied by infrastructure providers. Raw IP
      addresses are not intended to be stored in the ADarveo event pipeline.
    </p>
    <p>
      If you submit an enquiry or request access, we store your name, email address, optional phone
      number and company, service interests, goals, timeframe, submission time, and contact permission
      in Supabase. We use these details to respond to your interest in ADarveo. Access requests are also
      sent to our team by email through Resend so we can follow up. Submitting a request does not create
      an account or subscribe you to a mailing list. A keyed, hashed network identifier helps limit spam;
      this form does not store your raw IP address. You can ask us to stop contacting you or delete
      your enquiry using the contact details below.
    </p>

    <h2>How we use information</h2>
    <p>
      We use information to operate accounts, deliver scan experiences, calculate usage, provide
      campaign analytics, prevent abuse, troubleshoot problems, respond to support requests, meet legal
      obligations, and improve reliability. We do not sell personal information.
    </p>

    <h2>Public scans and destination links</h2>
    <p>
      Public scan pages do not ask visitors for contact information. Campaign owners may configure a
      destination such as a website, WhatsApp link, booking page, or phone link. ADarveo records the CTA
      interaction, but the destination’s own privacy practices apply after a visitor leaves ADarveo.
    </p>

    <h2>Service providers</h2>
    <p>
      ADarveo uses specialized providers to operate the platform, including Paddle for orders and tax,
      Supabase for application data and authentication, Cloudflare for website and media delivery, and
      Google Cloud for marker compilation. These providers process information under their own terms
      and privacy obligations.
    </p>

    <h2>Cookies and local storage</h2>
    <p>
      ADarveo may use essential cookies or browser storage for authentication, security, session
      continuity, user preferences, anonymous scan-session measurement, and checkout operation. We do
      not use public scan pages to build cross-site advertising profiles.
    </p>

    <h2>Retention and security</h2>
    <p>
      Information is retained only as long as reasonably required for the service, contractual records,
      fraud prevention, dispute handling, and legal obligations. We use access controls, encrypted
      connections, and provider security controls, but no online system can guarantee absolute security.
    </p>

    <h2>International processing</h2>
    <p>
      Our providers may process information in countries other than yours. Where required, appropriate
      contractual or legal safeguards are used for international transfers.
    </p>

    <h2>Your choices and rights</h2>
    <p>
      Depending on your location, you may have rights to request access, correction, deletion,
      restriction, portability, or objection. Account holders can also update certain details in the
      dashboard. We may need to verify a request before acting on it.
    </p>

    <h2>Children</h2>
    <p>
      ADarveo is a business software service and is not directed to children. Account holders must be
      legally capable of entering into a business agreement in their jurisdiction.
    </p>

    <h2>Contact and updates</h2>
    <p>
      Privacy questions and data requests can be sent to{' '}
      <a href={`mailto:${siteDetails.supportEmail}`}>{siteDetails.supportEmail}</a>. We may update this
      policy as the service changes and will revise the date above when we do.
    </p>
  </PolicyLayout>
);
